import { Program } from '@coral-xyz/anchor'
import { getHedgeMintPublicKey, getPoolPublicKeyForMint, Vault } from 'hedge-web3'
import { StakingPool } from '../accounts/StakingPool'
import { HEDGE_PROGRAM_PUBLICKEY } from '../utils/HedgeConstants'

const LoadHedgeStakingPoolState = async (program: Program<Vault>): Promise<StakingPool> => {
  const hedgeMintPublickey = await getHedgeMintPublicKey(HEDGE_PROGRAM_PUBLICKEY)
  const [hedgeStakingPoolPublicKey] = await getPoolPublicKeyForMint(
    HEDGE_PROGRAM_PUBLICKEY,
    hedgeMintPublickey
  )
  const hedgeStakingPoolRaw = await program.account.stakingPool.fetch(hedgeStakingPoolPublicKey)
  const hedgeStakingPool = new StakingPool(hedgeStakingPoolRaw, hedgeStakingPoolPublicKey)

  return hedgeStakingPool
}

export default LoadHedgeStakingPoolState
